
// bundle-summary-state.js
class BundleState {
  constructor() {
    this.items = new Map();
    this.listeners = [];
  }

  setItem(id, data) {
    if (data.quantity > 0) {
      this.items.set(id, data);
    } else {
      this.items.delete(id);
    }

    this.#notify();
  }

  getAll() {
    return Array.from(this.items.values());
  }

  clear() {
    this.items.clear();
    this.#notify();
  }

  onChange(callback) {
    this.listeners.push(callback);

    // Immediately provide the current state
    callback(this.getAll());

    // Return unsubscribe function
    return () => {
      this.listeners = this.listeners.filter(
        (listener) => listener !== callback
      );
    };
  }

  #notify() {
    this.listeners.forEach((callback) => {
      callback(this.getAll());
    });
  }
}

window.BundleState = new BundleState();